var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-info-container"},[_c('p',[_vm._v(_vm._s(_vm.$t('step_nav.step'))+" "+_vm._s(_vm.step)+"/"+_vm._s(_vm.totalSteps)+": "+_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }